import video1 from "../assets/video1.mp4";
import video2 from "../assets/video2.mp4";
import video3 from "../assets/video3.mp4";




const Videos = () => {
  return (
    <div className="flex flex-col items-center mt-3 lg:mt-9">

      {/* Video Container */}
      <div className="flex flex-col sm:grid sm:grid-cols-2 gap-4 mt-10 justify-center w-full px-4 bg-black-100 p-4">
        <video
          autoPlay
          loop
          muted
          className="rounded-lg border border-blue-700 shadow-sm shadow-blue-500 w-full h-96 object-cover"
        >
          <source  src={video3} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <video
          autoPlay
          loop
          muted
          className="rounded-lg border border-blue-700 shadow-sm shadow-blue-500 w-full h-96 object-cover "
        >
          <source  src={video3} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
};

export default Videos;
